// word can be "word" or "one-word" or "one_word" or "one.word"
export const validateOneWord = (value: string) => {
  return (
    /^[a-zA-Z-_.]+$/.test(value) ||
    'Field should contain only letters and symbols "_", "."'
  );
};
